<div class="space-y-8 relative">
  <!-- Header -->
  <div class="flex items-center justify-between">
    <div class="flex items-center gap-4">
      <button
        (click)="goBack()"
        class="inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 hover:bg-gray-100 dark:hover:bg-gray-800 h-9 w-9 hover:cursor-pointer"
      >
        <lucide-icon [img]="ArrowLeft" class="w-4 h-4"></lucide-icon>
      </button>
      <div>
        <h1 class="text-3xl font-bold text-gray-900 dark:text-gray-100 italic">
          {{ 'POS_TERMINALS.TITLE' | translate }}
        </h1>
        <p class="text-gray-600 dark:text-gray-400 mt-1">
          {{ 'POS_TERMINALS.SUBTITLE' | translate }}
        </p>
      </div>
    </div>
    <button
      (click)="openCreate()"
      class="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors bg-gray-900 text-gray-50 dark:bg-gray-100 dark:text-gray-900 hover:bg-gray-900/90 h-10 px-4 py-2 hover:cursor-pointer"
    >
      <lucide-icon [img]="Plus" class="w-4 h-4 mr-2"></lucide-icon>
      {{ 'POS_TERMINALS.ADD' | translate }}
    </button>
  </div>

  <!-- Create Dialog -->
  @if (isCreateOpen()) {
    <div class="fixed inset-0 z-50 flex items-center justify-center p-4">
      <!-- eslint-disable-next-line -->
      <div class="absolute inset-0 bg-black/50" (click)="closeCreate()"></div>
      <div
        class="relative bg-white dark:bg-gray-900 rounded-xl shadow-lg w-full max-w-md mx-4 flex flex-col overflow-hidden"
      >
        <div class="p-6 border-b border-gray-100 dark:border-gray-800">
          <h2 class="text-lg font-semibold leading-none tracking-tight">
            {{ 'POS_TERMINALS.CREATE_TITLE' | translate }}
          </h2>
          <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">
            {{ 'POS_TERMINALS.CREATE_SUBTITLE' | translate }}
          </p>
        </div>

        @if (createError()) {
          <div
            class="mx-6 mt-4 p-3 bg-red-50 dark:bg-red-900/20 text-red-600 rounded-lg text-sm flex items-center gap-2"
          >
            <lucide-icon [img]="AlertCircle" class="w-4 h-4"></lucide-icon>
            {{ createError() }}
          </div>
        }

        <form (submit)="handleCreate()" class="p-6 space-y-4">
          <div class="space-y-2">
            <label for="" class="text-sm font-medium leading-none font-semibold">{{
              'POS_TERMINALS.NAME_LABEL' | translate
            }}</label>
            <input
              name="name"
              [(ngModel)]="createForm.name"
              [placeholder]="'POS_TERMINALS.NAME_PH_CREATE' | translate"
              class="flex h-10 w-full rounded-md border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-950"
            />
          </div>
          <div class="pt-2 flex justify-end items-center gap-2">
            <button
              type="button"
              (click)="closeCreate()"
              class="inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-gray-900 dark:text-gray-100 h-10 px-4 py-2 hover:cursor-pointer"
            >
              {{ 'POS_TERMINALS.CANCEL' | translate }}
            </button>
            <button
              type="submit"
              [disabled]="isCreateLoading()"
              class="inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors bg-gray-900 text-gray-50 dark:bg-gray-100 dark:text-gray-900 hover:bg-gray-900/90 h-10 px-4 py-2 hover:cursor-pointer disabled:opacity-50"
            >
              {{ 'POS_TERMINALS.CREATE_BTN' | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  }

  <!-- Edit Dialog -->
  @if (isEditOpen()) {
    <div class="fixed inset-0 z-50 flex items-center justify-center p-4">
      <!-- eslint-disable-next-line -->
      <div class="absolute inset-0 bg-black/50" (click)="closeEdit()"></div>
      <div
        class="relative bg-white dark:bg-gray-900 rounded-xl shadow-lg w-full max-w-md mx-4 flex flex-col overflow-hidden"
      >
        <div class="p-6 border-b border-gray-100 dark:border-gray-800">
          <h2 class="text-lg font-semibold leading-none tracking-tight">
            {{ 'POS_TERMINALS.EDIT_TITLE' | translate }}
          </h2>
          <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">
            {{ 'POS_TERMINALS.EDIT_SUBTITLE' | translate }}
          </p>
        </div>

        @if (editError()) {
          <div
            class="mx-6 mt-4 p-3 bg-red-50 dark:bg-red-900/20 text-red-600 rounded-lg text-sm flex items-center gap-2"
          >
            <lucide-icon [img]="AlertCircle" class="w-4 h-4"></lucide-icon>
            {{ editError() }}
          </div>
        }

        <form (submit)="handleEdit()" class="p-6 space-y-4">
          <div class="space-y-2">
            <label for="" class="text-sm font-medium leading-none font-semibold">{{
              'POS_TERMINALS.NAME_LABEL' | translate
            }}</label>
            <input
              name="name"
              [(ngModel)]="editForm.name"
              [placeholder]="'POS_TERMINALS.NAME_PH_EDIT' | translate"
              class="flex h-10 w-full rounded-md border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-950"
            />
          </div>
          <div class="flex items-center gap-3 py-1">
            <input
              type="checkbox"
              id="editIsActive"
              name="isActive"
              [(ngModel)]="editForm.isActive"
              class="w-4 h-4 text-gray-900 border-gray-300 rounded cursor-pointer"
            />
            <label
              for="editIsActive"
              class="text-sm font-medium text-gray-700 dark:text-gray-300 cursor-pointer"
            >
              {{ 'POS_TERMINALS.ACTIVE_STATUS' | translate }}
            </label>
          </div>
          <div class="pt-2 flex justify-end items-center gap-2">
            <button
              type="button"
              (click)="closeEdit()"
              class="inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-gray-900 dark:text-gray-100 h-10 px-4 py-2 hover:cursor-pointer"
            >
              {{ 'POS_TERMINALS.CANCEL' | translate }}
            </button>
            <button
              type="submit"
              [disabled]="isEditLoading()"
              class="inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors bg-gray-900 text-gray-50 dark:bg-gray-100 dark:text-gray-900 hover:bg-gray-900/90 h-10 px-4 py-2 hover:cursor-pointer disabled:opacity-50"
            >
              {{ 'POS_TERMINALS.SAVE' | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  }

  <!-- Loading State -->
  @if (isLoading() && posList().length === 0) {
    <div class="flex flex-col items-center justify-center py-24 space-y-4">
      <div
        class="w-10 h-10 border-4 border-gray-200 border-t-gray-900 rounded-full animate-spin"
      ></div>
      <p class="text-gray-500">{{ 'POS_TERMINALS.LOADING' | translate }}</p>
    </div>
  } @else if (errorMessage()) {
    <div class="flex flex-col items-center justify-center py-24 space-y-4 text-red-500">
      <lucide-icon [img]="AlertCircle" class="w-12 h-12"></lucide-icon>
      <p>{{ errorMessage() }}</p>
    </div>
  } @else if (posList().length === 0) {
    <div class="flex flex-col items-center justify-center py-24 space-y-4 text-gray-400">
      <lucide-icon [img]="Monitor" class="w-12 h-12"></lucide-icon>
      <p>{{ 'POS_TERMINALS.EMPTY' | translate }}</p>
    </div>
  } @else {
    <div class="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
      @for (pos of posList(); track pos.id) {
        <div
          class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 text-gray-950 dark:text-gray-100 shadow-sm overflow-visible relative"
        >
          <div class="p-6 pb-3">
            <div class="flex items-start justify-between">
              <div class="flex items-center gap-3">
                <div class="p-2 bg-gray-100 dark:bg-gray-800 rounded-lg">
                  <lucide-icon
                    [img]="Monitor"
                    class="w-5 h-5 text-gray-600 dark:text-gray-400"
                  ></lucide-icon>
                </div>
                <div>
                  <h3 class="font-semibold text-lg leading-tight">{{ pos.name }}</h3>
                  <div class="mt-1">
                    @if (pos.isActive) {
                      <span
                        class="inline-flex items-center gap-1 px-2 py-0.5 text-xs rounded-full font-semibold bg-emerald-100 text-emerald-700 border border-emerald-200"
                      >
                        <lucide-icon [img]="CheckCircle" class="w-3 h-3"></lucide-icon>
                        {{ 'POS_TERMINALS.ACTIVE' | translate }}
                      </span>
                    } @else {
                      <span
                        class="inline-flex items-center gap-1 px-2 py-0.5 text-xs rounded-full font-semibold bg-red-100 text-red-600 border border-red-200"
                      >
                        <lucide-icon [img]="XCircle" class="w-3 h-3"></lucide-icon>
                        {{ 'POS_TERMINALS.INACTIVE' | translate }}
                      </span>
                    }
                  </div>
                </div>
              </div>

              <!-- Three-dot menu -->
              <div class="relative inline-block text-left group">
                <button
                  class="inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors hover:bg-gray-100 dark:hover:bg-gray-800 h-9 w-9 hover:cursor-pointer"
                >
                  <lucide-icon [img]="MoreVertical" class="w-4 h-4"></lucide-icon>
                </button>
                <div
                  class="hidden group-hover:block absolute right-0 z-10 w-44 origin-top-right rounded-md bg-white dark:bg-gray-900 shadow-lg ring-1 ring-black ring-opacity-5 border border-gray-100 dark:border-gray-800"
                >
                  <div class="py-1">
                    <button
                      (click)="openEdit(pos)"
                      class="w-full text-left flex items-center px-4 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-700 dark:text-gray-300 hover:cursor-pointer"
                    >
                      <lucide-icon [img]="Edit" class="w-4 h-4 mr-2"></lucide-icon>
                      {{ 'POS_TERMINALS.EDIT_MENU' | translate }}
                    </button>
                    <button
                      (click)="handleDelete(pos.id)"
                      class="w-full text-left flex items-center px-4 py-2 text-sm hover:bg-red-50 dark:hover:bg-red-900/20 text-red-600 hover:cursor-pointer"
                    >
                      <lucide-icon [img]="Trash2" class="w-4 h-4 mr-2"></lucide-icon>
                      {{ 'POS_TERMINALS.DELETE_MENU' | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Body -->
          <div class="px-6 pb-6 space-y-3">
            <!-- Activation Code -->
            <div
              class="rounded-lg border border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-800/50 p-3"
            >
              <p class="text-xs text-gray-500 dark:text-gray-400 mb-1.5 font-medium">
                {{ 'POS_TERMINALS.ACTIVATION_CODE' | translate }}
              </p>
              <div class="flex items-center gap-2">
                <span
                  class="font-mono text-sm font-semibold tracking-widest flex-1 text-gray-900 dark:text-gray-100"
                >
                  @if (isCodeVisible(pos.id)) {
                    {{ pos.activationCode }}
                  } @else {
                    &#x2022;&#x2022;&#x2022;&#x2022;&#x2022;&#x2022;&#x2022;&#x2022;
                  }
                </span>

                <!-- Eye toggle -->
                <button
                  (click)="toggleCodeVisibility(pos.id)"
                  class="inline-flex items-center justify-center rounded-md h-7 w-7 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors hover:cursor-pointer"
                  [title]="
                    (isCodeVisible(pos.id) ? 'POS_TERMINALS.HIDE_CODE' : 'POS_TERMINALS.VIEW_CODE')
                      | translate
                  "
                >
                  @if (isCodeVisible(pos.id)) {
                    <lucide-icon [img]="EyeOff" class="w-4 h-4 text-gray-500"></lucide-icon>
                  } @else {
                    <lucide-icon [img]="Eye" class="w-4 h-4 text-gray-500"></lucide-icon>
                  }
                </button>

                <!-- Refresh / Regenerate -->
                <button
                  (click)="regenerateCode(pos)"
                  [disabled]="isRegenerating(pos.id)"
                  class="inline-flex items-center justify-center rounded-md h-7 w-7 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors hover:cursor-pointer disabled:opacity-50"
                  [title]="'POS_TERMINALS.REFRESH_CODE' | translate"
                >
                  <lucide-icon
                    [img]="RefreshCw"
                    class="w-4 h-4 text-gray-500"
                    [class.animate-spin]="isRegenerating(pos.id)"
                  ></lucide-icon>
                </button>
              </div>
            </div>

            <!-- Expires At -->
            <div class="flex items-center justify-between text-sm">
              <span class="text-gray-500 dark:text-gray-400">{{
                'POS_TERMINALS.EXPIRES_AT' | translate
              }}</span>
              <span class="font-medium text-gray-700 dark:text-gray-300">
                {{ formatDate(pos.activationCodeExpiresAt) }}
              </span>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>

<p-confirmdialog [style]="{ width: 'min(30rem, 92vw)' }" />
